import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { FilterPill } from '@app/_components/lf-table/internal/FilterPill';
import { isPresent } from '@farmai-shared/LFUtils';
import { useTranslation } from 'react-i18next';
import { useActiveSeason, useActiveYear, useActiveCrop, useActiveLabel, useActiveCountry, useActiveDistrict, useActiveProvince, useActiveSubdistrict, useActiveVillage } from './hooks';
import { sendGaEvent } from '@services/utils';
export const FilterChipsHeader: FC = observer(() => {
  const {
    t
  } = useTranslation();
  const {
    seasonId: season_id,
    activeSeason,
    defaultSeason,
    setSeason
  } = useActiveSeason();
  const {
    yearParam,
    defaultYear,
    activeYearDisplay,
    setYear
  } = useActiveYear();
  const {
    cropParam,
    setActiveCrop
  } = useActiveCrop();
  const {
    labels,
    removeLabel
  } = useActiveLabel();
  const {
    countries,
    setActiveCountry,
    countryParam,
    activeCountryLabel
  } = useActiveCountry();
  const {
    setActiveProvince,
    provinceParam,
    activeProvinceLabel
  } = useActiveProvince();
  const {
    setActiveDistrict,
    districtParam,
    activeDistrictLabel
  } = useActiveDistrict();
  const {
    setActiveSubdistrict,
    subdistrictParam,
    activeSubdistrictLabel
  } = useActiveSubdistrict();
  const {
    setActiveVillage,
    villageParam,
    activeVillageLabel
  } = useActiveVillage();
  const handleRemove = (handleClick: VoidFunction) => {
    handleClick();
    sendGaEvent('remove_overview_tag', {
      event_category: 'overview',
      action: 'click'
    });
  };
  return <div className={`
        flex w-full shrink-0 flex-wrap gap-x-3 gap-y-4 overflow-x-auto
        md:px-10
      `}>
      {season_id && <FilterPill label={t('season')} value={activeSeason?.name || ''} disabled={season_id === defaultSeason?.id} onRemove={() => handleRemove(() => setSeason(defaultSeason?.id || null))} />}
      {isPresent(yearParam) && <FilterPill label={t('year')} value={activeYearDisplay || ''} disabled={yearParam === defaultYear} onRemove={() => handleRemove(() => setYear(defaultYear))} />}
      {cropParam && <FilterPill label={t('crop')} value={cropParam} onRemove={() => handleRemove(() => setActiveCrop(null))} />}
      {countries.length > 1 && countryParam && <FilterPill label={t('country')} value={activeCountryLabel}
    // For administrative levels, `setActive_` handles clearly children.
    onRemove={() => handleRemove(() => setActiveCountry(null))} />}

      {provinceParam && <FilterPill label={t('province')} value={activeProvinceLabel as string} onRemove={() => handleRemove(() => setActiveProvince(null))} />}

      {districtParam && <FilterPill label={t('district')} value={activeDistrictLabel as string} onRemove={() => handleRemove(() => setActiveDistrict(null))} />}

      {subdistrictParam && <FilterPill label={t('subdistrict')} value={activeSubdistrictLabel as string} onRemove={() => handleRemove(() => setActiveSubdistrict(null))} />}

      {villageParam && <FilterPill label={t('village')} value={activeVillageLabel as string} onRemove={() => handleRemove(() => setActiveVillage(null))} />}

      {labels.map(currentLabel => <FilterPill key={currentLabel.id} label={t('label')} value={currentLabel.label} onRemove={() => handleRemove(() => removeLabel(currentLabel.id))} />)}
    </div>;
});